import axiosClient from './axiosClient';

export const activityLogsApi = {
  getActivityLogs(establishmentId, params = {}) {
    return axiosClient.get(`/establishments/${establishmentId}/activity-logs`, {
      params,
    });
  },

  getActivitySummary(establishmentId) {
    return axiosClient.get(`/establishments/${establishmentId}/activity-logs/summary`);
  },
};

export default activityLogsApi;